import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import '../styles/styles.css';

const Collections = () => {
    const [collections, setCollections] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { user } = useAuth();

    // Placeholder collections data - will be replaced with API calls
    const placeholderCollections = [
        {
            id: 1,
            title: "Comfort Food Classics",
            description: "Warm, hearty recipes that feel like a hug",
            image: "/api/placeholder/300/200",
            recipeCount: 12,
            category: "comfort"
        },
        {
            id: 2,
            title: "Quick & Easy Weeknight Dinners",
            description: "30-minute meals for busy schedules",
            image: "/api/placeholder/300/200",
            recipeCount: 15,
            category: "quick"
        },
        {
            id: 3,
            title: "Healthy Mediterranean",
            description: "Fresh, nutritious recipes from the Mediterranean",
            image: "/api/placeholder/300/200",
            recipeCount: 20,
            category: "healthy"
        }
    ];

    useEffect(() => {
        // Simulate API call
        const fetchCollections = async () => {
            try {
                setLoading(true);
                // TODO: Replace with actual API call
                // const response = await getCollections();
                setTimeout(() => {
                    setCollections(placeholderCollections);
                    setLoading(false);
                }, 500);
            } catch (err) {
                setError('Failed to load collections. Please try again later.');
                setLoading(false);
            }
        };

        fetchCollections();
    }, []);

    if (loading) {
        return (
            <div className="collections-container">
                <div className="text-center py-2">
                    <h2>Loading collections...</h2>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="collections-container">
                <div className="error-message">{error}</div>
            </div>
        );
    }

    return (
        <div className="collections-container">
            <div className="collections-header">
                <h1 className="collections-title">Recipe Collections</h1>
                <p className="collections-subtitle">
                    Discover curated recipe collections organized by theme, cuisine, and cooking style
                </p>
            </div>

            <div className="collections-grid">
                {collections.map((collection) => (
                    <div key={collection.id} className="collection-card">
                        <div className="collection-image">
                            <img src={collection.image} alt={collection.title} />
                        </div>
                        <div className="collection-content">
                            <h3 className="collection-title">{collection.title}</h3>
                            <p className="collection-description">{collection.description}</p>
                            <div className="collection-meta">
                                <span className="recipe-count">{collection.recipeCount} recipes</span>
                                <span className="collection-category">{collection.category}</span>
                            </div>
                            <Link 
                                to={`/collections/${collection.id}`} 
                                className="collection-link"
                            >
                                Explore Collection
                            </Link>
                        </div>
                    </div>
                ))}
            </div>

            {user && (
                <div className="collections-cta">
                    <h3>Want to create your own collection?</h3>
                    <p>Check out your Recipe Books to organize your favorite recipes!</p>
                    <Link to="/my-recipes" className="btn-large">
                        My Recipe Books
                    </Link>
                </div>
            )}
        </div>
    );
};

export default Collections;